import { render, staticRenderFns } from "./ExtradataIcon.vue?vue&type=template&id=89608f46&"
import script from "./ExtradataIcon.vue?vue&type=script&lang=js&"
export * from "./ExtradataIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports